import React from 'react'
import { ChevronRight, IconCheckCircle } from '@yy/one-icon'
import styles from './index.module.less'

export interface ContentProps {
  Icon: React.ReactNode
  title: string
  content: string
  handleClick: () => void
  checked?: boolean
}

export const Content: React.FC<ContentProps> = (props) => {
  const { Icon, title, content, handleClick, checked = false } = props

  return (
    <div className={styles.content} onClick={handleClick}>
      <div className={styles.left}>
        <div className={styles.icon}>{checked ? <IconCheckCircle origin /> : Icon}</div>
      </div>
      <div className={styles.right}>
        <h6>{title}</h6>
        <p>{content}</p>
      </div>
      <div className={styles.arrow}>
        <ChevronRight />
      </div>
    </div>
  )
}

Content.displayName = 'Content'
